var map = {
	"./1.png": 1199,
	"./2.png": 4151,
	"./3.png": 3110,
	"./4.png": 9051,
	"./5.png": 2375,
	"./555.png": 9902,
	"./championship.png": 1285,
	"./dice.png": 7350,
	"./digital.png": 6641,
	"./discount.png": 2403,
	"./donation.png": 808,
	"./elearning.png": 1597,
	"./location.png": 6780,
	"./logo.png": 6949,
	"./money-bag.png": 9990,
	"./overlay-mobile.png": 8467,
	"./overlay-tab.png": 6900,
	"./overlay.png": 149,
	"./salary.png": 7139,
	"./tournament.png": 8191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;